import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './Components/NavBar/Navbar';
import Home from './Components/Home/Home';
import Games from './Components/Games/Games';
import Footer from './Components/Footer/Footer';
import Career from './Components/Career/Career';
import SpaceMathster from  './Components/Games/SpaceMathster';
import SpaceMathster2 from './Components/Games/SpaceMathster2';
import TriangleGame from './Components/Games/TriangleGame';
import SuccessSubmission from './Components/UIelements/SuccessSubmission';
import Applications from './Components/Application/ApplicationsPage';
import Reso from './Components/Application/Reso';
import Data from './Components/DataManagement/DataManagement';

const App = () => {
  return (
      <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
    <Router>
      <Navbar /> 
      <Routes>
      {/* URLパスと特定のコンポーネントとのマッピングを定義 */}
      <Route path='/' element={<Home/>} />  
        <Route path='/home' element={<Home/>} />   
        <Route path='/games' element={<Games/>} />
        <Route path='/applications' element={<Applications/>} />
        <Route path='/career' element={<Career/>} />
        <Route path='/data-management' element={<Data/>} />
        <Route path='/success' element={<SuccessSubmission/>} />
        <Route path='/product-details/spacemathster' element={<SpaceMathster/>} />
        <Route path='/product-details/spacemathster2' element={<SpaceMathster2/>} />
        <Route path='/product-details/triangleGame' element={<TriangleGame/>} />
        <Route path='/application-details/reso' element={<Reso/>} />
        
      </Routes>
    </Router>
   
    <Footer />
    </div>
  );
};

export default App;
